import React from "react";

const StudentTable = ({ headers, borderActive, children }) => {
  return (
    <table className="text-base w-full border border-slate-600/50 rounded-md my-4">
      <thead>
        <tr className={`${borderActive && "border-b border-slate-600/50"}`}>
          {headers.map((header, index) => (
            <th key={`${index}_${header}`} className="table-th !text-center">
              {header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>{children}</tbody>
    </table>
  );
};

export default StudentTable;
